import * as React from "react";
import { IIdColorTitle } from "../../../models/common/idColorTitle";
import { Base } from "../../../framework/base";
import { Box, Typography } from "@mui/material";

export interface IEventEditUrgencyClassStateTextProp {
  urgencyClass: IIdColorTitle;
  thick?: boolean;
  wide?: boolean;
}

export class EventEditUrgencyClassStateText extends React.Component<
  IEventEditUrgencyClassStateTextProp,
  {}
> {
    render() {
        const props = this.props;
        const backColor = props.urgencyClass?.color;
        const textColor = Base.invertColor(backColor);
        const bordered = Base.isWhite(backColor);
        return (
            <Box
                sx={{
                    backgroundColor: backColor,
                    color: textColor,
                    border: bordered ? "1px solid lightgray" : null,
                    lineHeight: bordered ? "22px" : null,
                    textAlign: "center",
                    width: props.wide ? "100%" : undefined,
                    borderRadius: "8px",
                }}
            >
                <Typography paddingLeft="8px" paddingRight="8px">{props.urgencyClass?.title}</Typography>
            </Box>
        );
    }
}
